/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{font-weight:500!important}.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{display:none}.error-message[_ngcontent-%COMP%]{color:#b00020;font-size:12px}"];
export { styles as styles };
